<template>
  <Observer
    :tag="tag"
    class="swiper-container"
    @show="swiper && $parent.$emit('show')"
    @visible="swiper && $parent.$emit('visible', $event)"
    @ob-click="$parent.$emit('SlideClick', $event)"
  >
    <slot />
    <div v-if="showPagination" ref="pagination" class="pagination" />
  </Observer>
</template>

<script>
// require sources
// import Swiper from 'swiper'

// as of swiper 4.0.7
// http://idangero.us/swiper/api/#events
const DEFAULT_EVENTS = [
  'Init',
  'SwiperCreated',
  'SlideClick',
  'SlidePrev',
  'SlideNext',
  'SlideChangeStart',
  'SlideChangeEnd',
  'ImagesReady',
  'Autoplay'
]

// export
export default {
  name: 'Swiper',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    options: {
      type: Object,
      default: () => ({})
    },
    globalOptions: {
      type: Object,
      required: false,
      default: () => ({
        loop: false,
        onlyExternal: true,
        paginationClickable: true,
        autoplayDisableOnInteraction: false
      })
    },
    showPagination: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      swiper: null
    }
  },
  mounted() {
    this.mountInstance()
  },
  activated() {
    // this.update()
  },
  updated() {
    this.update()
  },
  beforeDestroy() {
    this.$nextTick(function() {
      if (this.swiper) {
        this.swiper.destroy && this.swiper.destroy()
        delete this.swiper
      }
    })
  },
  methods: {
    update() {
      if (this.swiper) {
        this.swiper.reInit()
      }
    },
    mountInstance() {
      const swiperOptions = { ...this.globalOptions, ...this.options }
      this.showPagination && (swiperOptions.pagination = this.$refs.pagination)
      this.swiper = new Swiper(this.$el, swiperOptions)
      this.swiper.getIndex = () =>
        swiperOptions.loop
          ? this.swiper.activeLoopIndex
          : this.swiper.activeIndex
      this.bindEvents()
      this.$emit('ready', this.swiper)
    },
    bindEvents() {
      const vm = this
      const $parent = this.$parent
      DEFAULT_EVENTS.forEach((eventName) => {
        this.swiper.addCallback(eventName, function() {
          vm.$emit(eventName, ...arguments)
          // vm.$emit(eventName.replace(/([A-Z])/g, '-$1').toLowerCase(), ...arguments)
          $parent.$emit(eventName, ...arguments)
        })
      })
    }
  }
}
</script>
